import { useRef } from 'react';
import TopLoadingBar from 'react-top-loading-bar';
import { usePendingRequestsCount } from '@/requests/axios.store';

const LOADING_BAR_COLOR = '#2299DD';

export const OldLoadingBar = () => {
  const pendingRequests = usePendingRequestsCount();
  const progress = useRef(100);
  const newProgress = 100 / (1 + pendingRequests);
  if (progress.current === 100 || progress.current < newProgress) {
    progress.current = newProgress;
  }

  return <TopLoadingBar color={LOADING_BAR_COLOR} progress={progress.current} height={3} />;
};
